<template>
    <ion-page>
        <base-layout>
            <ion-card>
                <ion-card-content>
                    <ion-text>
                        <div class="ion-text-center mb-15">
                            <strong>{{ updateInformation }}</strong>
                        </div>
                    </ion-text>
                    <div class="ion-text-center">
                        <ion-button type="button" @click="openUpdateURL();" class="ion-text-center">{{ $t('download') }}</ion-button>
                    </div>
                </ion-card-content>
            </ion-card>
        </base-layout>
    </ion-page>
</template>

<script>
import {IonPage, IonText, IonCard, IonCardContent, IonButton} from '@ionic/vue';
import BaseLayout from '../components/base/BaseLayout.vue';
import { Browser } from '@capacitor/browser';

export default {
    components: {BaseLayout, IonPage, IonText, IonCard, IonCardContent, IonButton},
    data() {
        const updateInformationVal = localStorage.getItem('updateInformation');
        const updateURL = localStorage.getItem('updateURL');

        return {
            updateInformation: (updateInformationVal != null && updateInformationVal != undefined && updateInformationVal != '') ? updateInformationVal : this.$t('plaseUpdateTheAppToUse'),
            updateURL: (updateURL != null && updateURL != undefined && updateURL != '') ? updateURL : 'https://crm.matrixhu.com/notRewrite/app/',
        };
    },
    methods: {
        async openUpdateURL() {
            await Browser.open({ url: this.updateURL });
        }
    }
}
</script>